import React, { Component } from 'react'
import './MenuButton.css'

import { HamburgerSpring  } from 'react-animated-burgers'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'

export default class MenuButton extends Component {
	constructor(props) {
		super(props)

		this.state = {
			show: false
		}
	}
	componentDidMount() {
		setTimeout(() => {
			this.setState({ show: true })
		}, 100)
	}

	render() {
		let { show } = this.state
		let { active, whiteBg, visible } = this.props

		let menuButton = 'menuButton'
		
		if(show)
			menuButton += ' visible'

		let hamburger = 'hamburger hamburger--spring'

		if(active)
			hamburger += ' is-active'
		if(whiteBg)
			hamburger += ' whiteBg'

		// <FontAwesomeIcon id='icon' icon="bars" />

		/*
		<HamburgerSpring
		  className='menuIcon'
		  isActive={this.props.active} 
		  toggleButton={this.props.onMenuBtnClick}/>
		
		*/

		return (
			<div className={menuButton} onClick={this.props.onMenuBtnClick}>
				<div className={hamburger}>
				  <div className="hamburger-box">
				    <div className="hamburger-inner"></div>
				  </div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/MenuButton.js